// @flow
import type { ReduxAction } from '../../types';

export const lastAction = (state: null, action: ReduxAction) => {
  return action;
};
